import React from 'react';
import { registerRootComponent } from 'expo';
import 'expo-asset';
import 'expo-dev-client';

import { Root } from './src/Root';

const Index = () => <Root />;

registerRootComponent(Index);
